import ProfileIcon from 'assets/icons/profile-icon.svg?react';
import SignOutIcon from 'assets/icons/sign-out-icon.svg?react';
import { RoutePaths } from 'common-types';
import { SUPPORT_EMAIL } from 'utils';

import SupportIcon from '../assets/support-icon.svg?react';
import { IProfileDialogData } from './types';

export const profileDialogData: IProfileDialogData[] = [
  {
    title: 'Profile',
    href: RoutePaths.PROFILE,
    isRedirected: true,
    Icon: ProfileIcon,
  },
  {
    title: 'Support',
    href: `mailto:${SUPPORT_EMAIL}`,
    isNativeLink: true,
    Icon: SupportIcon,
  },
  {
    title: 'Log out',
    Icon: SignOutIcon,
    isLogOut: true,
  },
];
